// import axios from 'axios'
import Login from '../data/Login2'
import trace from 'app-core/lib/trace'
import qs from 'qs'
/**
 * 获取路由配置
 * @param res
 * @param data
 * @returns {*}
 */
function getRouteData(res, data, url) {
  let bizType = data._bizType_
  let routerData = null
  if (bizType) {
    switch (bizType) {
      case 'PAY_CORP_PAYMENT_FORM': // 公司支付
        routerData = {
          path: '/common/applyPayDetail',
          query: {
            id: data._bizId_,
            taskId: data._taskId_
          }
        }
        break
      case 'OTAM_TRAVEL_PLAN': // 差旅计划
        sessionStorage.setItem('ta_approval', JSON.stringify(data))
        sessionStorage.setItem('ta_url', url)
        routerData = {
          path: '/mg/control/plan/travelapproval',
          query: {
            // approval: JSON.stringify(data),
            // url2:url
          }
        }
        break
      case 'paySuccess': // 差旅申请
        switch (res.state) {
          case '99':
          case '0':
            routerData = {
              path: '/common/paySuccess',
              params: {
                // res: data
              }
            }
            break
        }
        break
      case 'gotoPay': // 差旅申请
        routerData = {
          path: '/common/aliPay',
          query: {
            goto: data.goto
          }
        }
        break
      case 'EC_ER_FORM': // 费控报销
        routerData = {
          path: '/mg/expense/erForm',
          query: {
            id: data._bizId_,
            taskId: data._taskId_
          }
        }
        break
    }
  }
  return routerData
}

/**
 * 处理url任务
 * @param url
 * @param v
 * @param showLoading
 * @param autoChangeUser
 */
function _proccessUrl(url, v, config) {
  if (url.indexOf('http') != -1) {
    url = decodeURIComponent(url).substring('http://'.length - 1)
  }

  console.log('-======_proccessUrl  url 000000 ', url)
  trace.log({
    type: 'proccessUrl',
    url,
    defaultUrl: sessionStorage.getItem('defaultUrl')
  })
  let conf = Object.assign(
    {
      showLoading: false,
      autoChangeUser: false,
      backName: null,
      replace: false
    },
    config
  )

  if (!url || !v) {
    console.error('缺少参数url or vue')
    return
  }
  let key = conf.key || sessionStorage.getItem('url_id')
  if (key && key !== 'null' && key !== 'undefined') {
    console.log('-======_proccessUrl  1111 ', key)
    trace.log({
      type: 'proccessUrl-1',
      url,
      key,
      defaultUrl: sessionStorage.getItem('defaultUrl')
    })
    // 直接打开详情
    sessionStorage.removeItem('defaultUrl')
    sessionStorage.removeItem('url_id')
    if (url == 'TravelPlan') {
      v.$router.push({
        path: '/common/traveldetails',
        query: {
          id: key,
          backName: 'home'
        }
      })
      return
    } else if (url == 'Order') {
      window.$jump.orderDetail(v, key, 'home')
      return
    } else if (url == 'Expense') {
      v.$router.push({
        path: '/mg/expense/erForm',
        query: { id: key, backName: 'home' }
      })
      return
    } else if (url == 'ApplyPay') {
      v.$router.replace({
        path: '/common/applyPayDetail',
        query: { uid: key, notitle: 1, backName: 'home' }
      })
      return
    }
  }
  if (config.showLoading) {
    v.$w.loading.show()
  }
  console.log('-======_proccessUrl  1111 ', key)
  if (url.indexOf('/home') != -1 || url.indexOf('/login') != -1) {
    location.href = location.origin + '/home'
  } else {
    trace.log({
      type: 'proccessUrl-2',
      url,
      defaultUrl: sessionStorage.getItem('defaultUrl')
    })
    window.$httpUtil.instance.get(url).then((response) => {
      sessionStorage.removeItem('defaultUrl')
      conf.showLoading && v.$w.loading.hide()
      console.log('-======_proccessUrl  3333 ', response.data)

      let res = response.data
      let data = res.data || {}
      trace.log({
        type: 'proccessUrl-3',
        url,
        defaultUrl: sessionStorage.getItem('defaultUrl'),
        data
      })
      // 需要切换用户查看
      if (data.changeUserToSee) {
        // 自动切换用户查看
        if (conf.autoChangeUser) {
          ;(async function () {
            let res = await Login.switchUser(data.changeUserToSee)
            if (res.code == '0') {
              v.$w.toast.show({
                type: 'text',
                text: '已切换至任务所属企业',
                width: '10rem',
                onHide() {
                  _proccessUrl(url, v, config)
                }
              })
            } else {
              toErrorPage(400)
            }
          })()
        } else {
          toErrorPage(-403)
        }
      } else {
        let rd = getRouteData(res, data, url)
        console.log('-======_proccessUrl  44444 ', rd)

        if (rd) {
          let backName = conf.backName
          if (backName) {
            rd.query ? (rd.query.backName = backName) : (rd.query = { backName })
          }
          if (config.isNeedGoGate && config.isNeedGoGate === true) {
            const routeUrl = v.$router.resolve(rd)
            let urlGo = location.origin + routeUrl.href
            trace.log({
              type: 'proccessUrl-4-1',
              url,
              defaultUrl: sessionStorage.getItem('defaultUrl'),
              rd,
              data,
              urlGo,
              zzzconfig: typeof window.zzzconfig != 'undefined'
            })
            window.zzzconfig?.goGatePage(urlGo, true, 'proccessUrl_js')
          } else {
            trace.log({
              type: 'proccessUrl-4-2',
              url,
              defaultUrl: sessionStorage.getItem('defaultUrl'),
              rd,
              data
            })
            window.$jump.goLocPage(rd.path + '?' + qs.stringify(rd.query))
            // v.$router[config.replace ? 'replace' : 'push'](rd)
          }

          if (config.msgId) {
            Login.readMessage(config.msgId)
          }
        } else {
          toErrorPage(res.code || 400)
        }
      }
    })
  }

  //   .catch(err => {
  //   conf.showLoading && v.$w.loading.hide()
  //   console.log(err)
  //   // toErrorPage(400)
  // })

  function toErrorPage(code) {
    window.$jump.goLocPage('/common/error?' + qs.stringify({ code, backName: conf.backName }))
  }
}

export default _proccessUrl
